import type { PropsWithChildren } from 'react';
import styled, { keyframes } from 'styled-components';
import { theme, useHoverIntent } from '@frameio/vapor';
import type { BannerWrapperProps } from '../types';

const animateIn = keyframes`
  from {
    grid-template-rows: 0fr;
  }
  to {
    grid-template-rows: 1fr;
  }
`;

const Wrapper = styled.div`
  animation: ${animateIn} 0.25s ${theme.transitions.eases.primary} forwards;
  animation-delay: 0.25s;
  display: grid;
  grid-template-rows: 0fr;
  will-change: grid-template-rows, opacity;
`;

const Content = styled.div`
  overflow: hidden;
  padding-top: ${theme.spaces[2]};
`;

export const BannerWrapper = ({ children }: PropsWithChildren) => {
  return (
    <Wrapper>
      <Content>{children}</Content>
    </Wrapper>
  );
};

export const UpgradeBannerWrapper = ({
  children,
  onHoverIntent,
}: BannerWrapperProps) => {
  const { bind: hoverIntent } = useHoverIntent(() => {
    onHoverIntent?.();
  });

  return (
    <Wrapper {...hoverIntent}>
      <Content>{children}</Content>
    </Wrapper>
  );
};
